import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drop-up",
  "use": "icon-drop-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-drop-up\">\n  <path stroke=\"#53933A\" d=\"M0.5 12C0.5 18.3513 5.64873 23.5 12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12Z\" />\n  <path d=\"M7.41 16L12 11.42L16.59 16L18 14.59L12 8.59L6 14.59L7.41 16Z\" fill=\"#53933A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol